import parseJWTPayload from "./utils/parseJWTPayload";
import apm from "utils/ApplicationMonitoring";
import getAccounts from "services/accounts/getAccounts";
import get from "utils/get";
import postAccount from "services/accounts/postAccount";
import login from "services/auth/login";
import register from "services/auth/register";
import refreshTokenService from "services/auth/refreshToken";
import sleep from "utils/sleep";

let refreshTokenLock = false;
export default class Auth {
  accessToken;
  expiresAt;

  login({ email, password, onError, history, supplier = null, tariff = null }) {
    login({ username: email, password })
      .then(res => {
        const {
          access_token: accessToken,
          refresh_token: refreshToken
        } = res.data;

        this.setTokens(accessToken, refreshToken);
        getAccounts().then(response => {
          let { accounts } = response.data;
          if (accounts.length === 0) {
            postAccount({ emailAddress: email, supplier, tariff })
              .then(() => {
                return getAccounts();
              })
              .then(response => {
                ({ accounts } = response.data);
                localStorage.setItem("accounts", JSON.stringify(accounts));
                const activeAccountId = get(accounts, "[0].accountId");
                const activeAccountName = get(accounts, "[0].accountName");
                localStorage.setItem(
                  "activeAccountId",
                  JSON.stringify(activeAccountId)
                );

                if (activeAccountId && email) {
                  apm.setUserContext({
                    id: activeAccountId,
                    name: activeAccountName,
                    email
                  });
                }

                history.push("/dashboard");
              })
              .catch(err => {
                history.push("/register");
              });
          } else {
            localStorage.setItem("accounts", JSON.stringify(accounts));
            const activeAccountId = get(accounts, "[0].accountId");
            const activeAccountName = get(accounts, "[0].accountName");

            localStorage.setItem(
              "activeAccountId",
              JSON.stringify(activeAccountId)
            );

            if (activeAccountId && email) {
              apm.setUserContext({
                id: activeAccountId,
                name: activeAccountName,
                email
              });
            }

            history.push("/dashboard");
          }
        });
      })
      .catch(onError);
  }

  constructor() {
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
    this.getAccessToken = this.getAccessToken.bind(this);
  }

  getAccessToken() {
    let token = localStorage.getItem("accessToken");
    if (token === null) {
      return "";
    }
    return token;
  }

  getAccessTokenPayload() {
    let accessToken = this.getAccessToken();
    if (!accessToken) {
      return {};
    }
    return parseJWTPayload(accessToken);
  }

  setTokens(accessToken, refreshToken) {
    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("refreshToken", refreshToken);
  }

  signup({ email, password, history, supplier, tariff }) {
    return register({ email, password }).then(() => {
      this.login({
        email,
        password,
        history,
        supplier,
        tariff,
        onError: err => {
          apm.captureError(err);
        }
      });
    });
  }

  logout() {
    localStorage.clear();
    apm.setUserContext({ id: null, name: null, email: null });
    window.location.href = window.location.origin;
  }

  checkIfAccessTokenHasExpired() {
    let hasAccessTokenExpired;
    const accessToken = this.getAccessTokenPayload();
    const { exp } = accessToken;
    if (!exp) {
      hasAccessTokenExpired = true;
    } else {
      const now = Math.floor(Date.now() / 1000);
      hasAccessTokenExpired = exp < now;
    }
    return hasAccessTokenExpired;
  }

  isAuthenticated() {
    if (refreshTokenLock) {
      return sleep(300).then(() => {
        return this.isAuthenticated();
      });
    }
    refreshTokenLock = true;
    const hasAccessTokenExpired = this.checkIfAccessTokenHasExpired();

    if (hasAccessTokenExpired) {
      let refreshToken = localStorage.getItem("refreshToken");
      if (refreshToken === null) {
        refreshTokenLock = false;
        return Promise.resolve(false);
      }

      return refreshTokenService({ refreshToken })
        .then(response => {
          const {
            access_token: accessToken,
            refresh_token: refreshToken
          } = response.data;
          this.setTokens(accessToken, refreshToken);
          const hasNewAccessTokenExpired = this.checkIfAccessTokenHasExpired();
          refreshTokenLock = false;
          return !hasNewAccessTokenExpired;
        })
        .catch(error => {
          refreshTokenLock = false;
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            this.logout();
          } else if (error.request) {
            // The request was made but no response was received
            // probably client is offline
            return false;
          } else {
            // Something happened in setting up the request that triggered an Error
            return false;
          }
        });
    }

    // current token has not expired
    refreshTokenLock = false;
    return Promise.resolve(true);
  }
}
